module.exports = __webpack_public_path__ + "img/km.281cd08c.jpg";